// V3 styled components collection
import styled from 'styled-components';
import {
  contentWidth,
  Button as ButtonV2,
  mobileThreshold,
  mobileSmallThreshold,
  tabletThresholdPixels,
  Container as ContainerV2,
  FormInput as FormInputV2,
  margins,
  menuBarHeightPixels, menuBarHeightWithBannerPixels,
  mobileMenuBarHeightPixels, mobileMenuBarHeightWithBannerPixels,
  Title1,
  Row,
} from '../v2/styledComponents';
import { colors } from '../v4/styledComponents';

export const frames = {
  desktop: '136px',
  tablet: '64px',
  mobile: '24px',
};

export const fontSizes = {
  xs: '12px',
  s: '16px',
  m: '18px',
  l: '24px',
  xl: '30px',
  x2l: '36px',
  x3l: '46px',
  x4l: '50px',
};

export const Title2 = styled.h2`
  font-weight: 700;
  line-height: 30px;
  font-size: 32px;
  text-align: center;
  color: ${colors.black};
  margin: 0px 0px ${({ marginBottom }) => marginBottom || 20}px;
  white-space: pre-wrap;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 220px;
    font-size: 20px;
    margin: 0px 15px ${({ marginBottom }) => marginBottom ? 40 : 0}px;
  }
`;

export const Title3 = styled.h2`
  font-weight: 700;
  line-height: 30px;
  font-size: 26px;
  letter-spacing: 2px;
  color: ${colors.black};
  margin: 0px 0px ${({ marginBottom }) => marginBottom ? 122 : 5}px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: ${fontSizes.m};
    margin: 0px 0px ${({ marginBottom }) => marginBottom ? 40 : 0}px;
    line-height: 23px;
  }
`;

export const Title4 = styled.h3`
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 5.5px;
  margin-bottom: 15px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 10px;
  }
`;

export const Subtitle2 = styled.span`
  font-family: Roboto;
  font-size: ${fontSizes.m};
  line-height: 23px;
  color: ${colors.black};
  text-align: center;
  margin: -10px 0px 20px;

  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 14px;
    margin: 0px 0px 20px;
    line-height: 19px;
  }
`;

export const StyledTitle2 = styled(Title2)`
  font-size: 110px;
  text-align: start;
  text-transform: uppercase;
  @media (max-width: ${tabletThresholdPixels}) {
    font-size: 26px;
  }
`;

export const Note = styled.p`
  font-family: Roboto;
  color: ${colors.black};
  line-height: 20px;
  font-size: ${fontSizes.s};
  margin-top: 20px;
  ${({ center }) => center && 'text-align: center;'}

  @media (max-width: ${tabletThresholdPixels}) {
    text-align: center;
    font-size: ${fontSizes.xs};
    margin-top: 10px;
    margin-bottom: 25px;
  }
`;

export const Container = styled(ContainerV2)`
  && {
    background-color: ${colors.beige100};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: ${({ hasNoBanner = true }) => hasNoBanner
    ? menuBarHeightPixels
    : menuBarHeightWithBannerPixels};

  @media (max-width: ${tabletThresholdPixels}) {
    margin-top: ${({ hasNoBanner = true }) => hasNoBanner
    ? mobileMenuBarHeightPixels
    : mobileMenuBarHeightWithBannerPixels};
    width: 100vw;
  }
`;

export const EndLine = styled.div`
  height: 1px;
  background-color: ${colors.black};
  width: 100%;
`;

export const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1166px;
  margin: 0 ${frames.desktop} ${(props) => props.noMarginBottom ? '0' : '120'}px;
  align-items: center;
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 0 40px;
    ${(props) => props.noMarginBottom && 'margin-bottom: 45px;'}
    max-width: 100vw;
    box-sizing: border-box;
  }
`;

export const ComponentsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${tabletThresholdPixels}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Button = styled(ButtonV2)`
  font-size: ${(props) => props.small ? '12px' : '16px'};
  text-align: center;
  border-radius: 4px;
  padding: 17px 30px;
  ${({ yellow }) => yellow && `background-color: ${colors.yellow900};`}
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    padding: 17px;
  }
`;

export const UpTitle = styled.div`
  font-family: Roboto;
  font-weight: 500;
  font-size: 12px;
  line-height: 30px;
  margin-bottom: 16px;
  text-align: center;
  text-transform: uppercase;
  color: ${colors.black};
  letter-spacing: 5.5px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 10px;
    line-height: 15px;
    margin-bottom: 10px;
  }
`;

export const DashTextContainer = styled.div`
  display: flex;
  align-items: center;

  &:before {
    font-weight: lighter;
    font-size: 32px;
    color: ${colors.white};
    z-index: 0;
    content: '——';
    letter-spacing: -10px;
    top: -19px;
    margin-right: ${margins.s};
    position: relative;
    border-bottom: ${colors.black} 1px solid;
  }
`;
export const Label = styled.label`
  color: ${colors.black};
  font-size: ${(props) => props.small ? '14px' : fontSizes.m};
`;

export const FormInput = styled(FormInputV2)`
  padding: 0 24px;
  height: 57px;
  width: 387px;
  border-radius: 4px;
  margin: 0;
  border: solid 1px ${colors.grey500};
  &::placeholder {
    color: ${(props) => props.error ? colors.red500 : colors.grey600};
    opacity: 1;
    font-size: 14px;
    font-family: Roboto;
  }
  @media (max-width: ${tabletThresholdPixels}) {
    width: 100%;
    padding: 0 22px;
    &::placeholder {
      font-size: 12px;
    }
  }
`;

export {
  contentWidth, mobileThreshold, mobileSmallThreshold, tabletThresholdPixels, margins,
  menuBarHeightPixels, menuBarHeightWithBannerPixels,
  mobileMenuBarHeightPixels, mobileMenuBarHeightWithBannerPixels, Title1, Row, colors,
};
